module.exports = __webpack_public_path__ + "media/images/lane/header-sign-c6035b6a1e9c245876c7e9391a7a601c.svg";